// extracted by mini-css-extract-plugin
export default {"container":"home_container__+bBuo","heading":"home_heading__ZnesS","table":"home_table__iPNpO"};